"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div id="ai-trainer">
    <llm-trainer></llm-trainer>
</div>`;
require("./styles/layout.scss");
const styles = T.css `#ai-chat {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
#ai-chat .chat-layout {
  display: flex;
  flex: 1;
  overflow: hidden;
}
#ai-chat .chat-layout conversation-list {
  flex-shrink: 0;
}
#ai-chat .chat-layout .chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#ai-chat .chat-layout .chat-main .ai-controls {
  display: flex;
  flex-direction: row;
  gap: 1em;
  margin: 1rem;
  justify-content: space-between;
  flex-shrink: 0;
}
#ai-chat .chat-layout .chat-main .ai-controls model-select {
  position: relative;
  z-index: 2;
}
#ai-chat .chat-layout .chat-main .ai-controls knowledge-picker {
  width: 300px;
  position: relative;
  z-index: 2;
}
#ai-chat .chat-layout .chat-main app-chat {
  flex: 1;
  position: relative;
  z-index: 1;
  overflow-x: scroll;
}

@media (max-width: 768px) {
  #ai-chat .chat-layout {
    flex-direction: column;
  }
  #ai-chat .chat-layout conversation-list {
    order: 2;
  }
  #ai-chat .chat-layout .chat-main {
    order: 1;
    flex: 1;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerPage = class TrainerPage extends client_1.RWSViewComponent {
};
exports.TrainerPage = TrainerPage;
exports.TrainerPage = TrainerPage = __decorate([
    (0, client_1.RWSView)('ai-trainer', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TrainerPage);
TrainerPage.defineComponent();
